export default __webpack_public_path__ + "static/media/investment_graph2.beee4191.svg";